module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEZSURBVHgB1ZTNDYJAEIUfaAFsB9gBHaglWIHagSTqWa8m/nWgFViCJWgJdLDGO4sz6yL+oGyEg75kwm4YvjfwAOAvNZcDqh4vHVSppfSQYEfV0nsXjTqqEsNj7GnkQO8TbBGKyEUVWkr/Cb7GUPR4Wf4RMVwRHPD1XmGKkZikp8sZFMDLGVjAM4OsmZNvczgF8MD0ewYeEnyV15qG7JlJ2OiAmQys4TH67+CZQSiOlHyHVid9YY1MFufuS/dCdm9wh3oV3e1YbPBBjxnw5HX9ofjGfkLm0xs8wcZcdaJq68EK9Boy55HQlPcmLGWODiKqjg083yDPJOuOzOQRLPX+Nb3+V9gk+Bb+2SA1idUKrtv8Bm4vNvpVXQDGMXKO4b1s5gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/selected.png
// module id = o1/X
// module chunks = 1